<template>
  <transition
    name="custom-classes-transition"
    enter-active-class="animated fadeInDown"
    leave-active-class="animated fadeOutUp"
    :duration="{ enter: 100, leave: 100 }"
  >
    <div
      v-if="errors && errors.length"
      class="mt-1 text-base font-semibold text-red-500 capitalize"
    >
      <span class="inline-block w-4 h-4 text-center text-white bg-red-500 rounded-full">!</span>
      {{ errors[0] }}
    </div>
  </transition>
</template>

<script setup>
defineProps({
  errors: {
    type: Array,
    default: () => undefined
  }
})
</script>
